import _Divider from "@mui/material/Divider";
import _Box from "@mui/material/Box";
import _Typography from "@mui/material/Typography";
import _Skeleton from "@mui/material/Skeleton";
import React from 'react';
import { useTranslation } from 'react-i18next';
import emptyStateIllustration from '../../../assets/images/find-illus.svg';
import { useChallenge } from '../../../hooks';
import PodiumCard, { podiumOrder, podiumRanksConfig } from '../../event/leaderboard/podium-card';
import { GeogroupAvatar } from '../../geogroup-avatar';
import LeaderboardCompanyItem from '../companies-leaderboard/item';
import SubgroupRankCard from './subgroup-rank-card';
export const fakeSites = [{
  key: 'tokyo',
  title: 'Tokyo',
  activeMembers: 2345,
  journeys: 12_345,
  distance: 456_789_012
}, {
  key: 'barcelone',
  title: 'Barcelone',
  activeMembers: 456,
  journeys: 1_234,
  distance: 23_456_789
}, {
  key: 'bordeaux',
  title: 'Bordeaux',
  activeMembers: 234,
  journeys: 2_345,
  distance: 34_567_890
}, {
  key: 'amsterdam',
  title: 'Amsterdam',
  activeMembers: 123,
  journeys: 789,
  distance: 34_567_890
}];
export const fakeTeams = [{
  key: 'dev',
  title: 'Développement',
  activeMembers: 2345,
  journeys: 12_345,
  distance: 456_789_012
}, {
  key: 'logistique',
  title: 'Logistique',
  activeMembers: 456,
  journeys: 1_234,
  distance: 23_456_789
}, {
  key: 'sav',
  title: 'Service client',
  activeMembers: 234,
  journeys: 2_345,
  distance: 34_567_890
}, {
  key: 'head',
  title: 'Direction',
  activeMembers: 123,
  journeys: 789,
  distance: 34_567_890
}];
export const fakeRegions = [{
  key: 'idf',
  title: 'île-de-France',
  activeMembers: 2345,
  journeys: 12_345,
  distance: 456_789_012
}, {
  key: 'nord',
  title: 'Nord',
  activeMembers: 456,
  journeys: 1_234,
  distance: 23_456_789
}, {
  key: 'so',
  title: 'Sud-Ouest',
  activeMembers: 234,
  journeys: 2_345,
  distance: 34_567_890
}, {
  key: 'ge',
  title: 'Grand Est',
  activeMembers: 123,
  journeys: 789,
  distance: 34_567_890
}];
function SubgroupsLeaderboard({
  FakeItemsCard,
  isFree,
  disableLeaderboardRestriction,
  event,
  freeOfferSubgroupsLeaderboardsMaxRowsCount,
  displayType,
  leaderboard,
  count,
  ownGroupId,
  ownGroupItem,
  onRowClick
}) {
  const {
    t
  } = useTranslation();
  const {
    getProgressValueWithUnit
  } = useChallenge();
  return !leaderboard || leaderboard.length > 0 || isFree && !disableLeaderboardRestriction && freeOfferSubgroupsLeaderboardsMaxRowsCount === 0 ? /*#__PURE__*/React.createElement(_Box, {
    display: "flex",
    flexDirection: "column",
    gap: 3,
    width: "100%"
  }, /*#__PURE__*/React.createElement(_Box, {
    alignItems: "flex-end",
    display: "flex",
    gap: 3,
    width: "100%"
  }, podiumOrder.map(({
    itemIndex,
    rank
  }) => {
    const item = leaderboard?.[itemIndex];
    const podiumLoading = !leaderboard;
    return /*#__PURE__*/React.createElement(PodiumCard, {
      avatar: podiumLoading || item ? /*#__PURE__*/React.createElement(GeogroupAvatar, {
        geogroup: item ? {
          title: item.username || ''
        } : undefined,
        size: podiumRanksConfig[rank].avatarSize
      }) : null,
      key: rank,
      rank: rank
    }, /*#__PURE__*/React.createElement(_Typography, {
      noWrap: true,
      fontSize: "0.9375rem",
      fontWeight: 600,
      title: item?.username || ''
    }, item ? item.username : podiumLoading ? /*#__PURE__*/React.createElement(_Skeleton, {
      variant: "text",
      width: "100%"
    }) : '–'), /*#__PURE__*/React.createElement(_Typography, {
      fontSize: "1.125rem",
      fontWeight: 800
    }, item ? getProgressValueWithUnit(event.challengeTemplate?.type || 'bttf', item.progressValue) : podiumLoading ? /*#__PURE__*/React.createElement(_Skeleton, {
      variant: "text",
      width: 100
    }) : '–'));
  })), /*#__PURE__*/React.createElement(SubgroupRankCard, {
    challengeTemplate: event.challengeTemplate,
    displayType: displayType,
    numberOfParticipants: count,
    progress: ownGroupItem
  }), /*#__PURE__*/React.createElement(_Box, {
    border: "1px solid #dde0e7",
    borderRadius: 2,
    display: "flex",
    flexDirection: "column",
    width: "100%"
  }, leaderboard ? /*#__PURE__*/React.createElement(React.Fragment, null, leaderboard.filter(({
    id
  }) => id).map(({
    id,
    rank,
    progressValue,
    username: title,
    participants
  }, index) => id && /*#__PURE__*/React.createElement(React.Fragment, {
    key: id
  }, index > 0 && /*#__PURE__*/React.createElement(_Divider, {
    sx: {
      borderColor: '#dde0e7'
    }
  }), /*#__PURE__*/React.createElement(LeaderboardCompanyItem, {
    challengeType: event.challengeTemplate?.type,
    item: {
      id,
      type: 'company',
      activeParticipantsCount: participants || 0,
      participantsCount: participants || 0,
      leaderboardIndex: index + 1,
      rank,
      progressValue,
      title: title || '',
      parentId: -1,
      parentPhoto: null,
      parentTitle: '',
      photo: null,
      sizeRange: null,
      certified: false
    },
    onRowClick: onRowClick,
    ownGeogroup: ownGroupId ? {
      id: ownGroupId
    } : null,
    prevItemRank: index > 0 ? leaderboard[index - 1].rank : null
  }))), isFree && !disableLeaderboardRestriction && count && count > freeOfferSubgroupsLeaderboardsMaxRowsCount && /*#__PURE__*/React.createElement(FakeSubgroups, {
    displayType: displayType,
    event: event,
    FakeItemsCard: FakeItemsCard,
    freeOfferEmployeesLeaderboardsMaxRowsCount: freeOfferSubgroupsLeaderboardsMaxRowsCount
  })) : new Array(10).fill(null).map((_, index) => /*#__PURE__*/React.createElement(React.Fragment, {
    key: index
  }, index > 0 && /*#__PURE__*/React.createElement(_Divider, {
    sx: {
      borderColor: '#dde0e7'
    }
  }), /*#__PURE__*/React.createElement(LeaderboardCompanyItem, {
    challengeType: event.challengeTemplate?.type,
    prevItemRank: null
  }))))) : /*#__PURE__*/React.createElement(_Box, {
    alignItems: "center",
    display: "flex",
    flexDirection: "column",
    gap: 3,
    paddingY: 5
  }, /*#__PURE__*/React.createElement("img", {
    height: 64,
    src: emptyStateIllustration
  }), /*#__PURE__*/React.createElement(_Box, {
    alignItems: "center",
    display: "flex",
    flexDirection: "column",
    gap: 1
  }, /*#__PURE__*/React.createElement(_Typography, {
    align: "center",
    fontWeight: 700
  }, t('commons.challenges.leaderboard.empty_state_title_company')), /*#__PURE__*/React.createElement(_Typography, {
    align: "center",
    variant: "body2"
  }, t('commons.challenges.leaderboard.empty_state_description'))));
}
function FakeSubgroups({
  FakeItemsCard,
  event,
  freeOfferEmployeesLeaderboardsMaxRowsCount,
  displayType
}) {
  const fakeGroups = displayType === 'companySite' || displayType === 'companySubsidiary' ? fakeSites : displayType === 'companyRegion' ? fakeRegions : fakeTeams;
  return /*#__PURE__*/React.createElement(_Box, {
    sx: {
      position: 'relative'
    }
  }, fakeGroups.map(({
    title,
    activeMembers
  }, index) => {
    const rank = freeOfferEmployeesLeaderboardsMaxRowsCount + 2;
    return /*#__PURE__*/React.createElement(React.Fragment, {
      key: index
    }, (index > 0 || freeOfferEmployeesLeaderboardsMaxRowsCount > 0) && /*#__PURE__*/React.createElement(_Divider, {
      sx: {
        borderColor: '#dde0e7'
      }
    }), /*#__PURE__*/React.createElement(LeaderboardCompanyItem, {
      blurred: true,
      challengeType: event.challengeTemplate?.type,
      item: {
        id: -1,
        type: 'company',
        activeParticipantsCount: 0,
        participantsCount: activeMembers,
        leaderboardIndex: rank + 1,
        rank,
        progressValue: 0,
        title,
        parentId: -1,
        parentPhoto: null,
        parentTitle: '',
        photo: null,
        sizeRange: null,
        certified: false
      },
      prevItemRank: freeOfferEmployeesLeaderboardsMaxRowsCount + 1
    }));
  }), /*#__PURE__*/React.createElement(FakeItemsCard, {
    isEventWithOffer: event
  }));
}
export default SubgroupsLeaderboard;